class EnquiryModel {
  EnquiryId = null;
  CustomerName = '';
  MobileNo = '';
  VehicleEnquiries = [];
}

export default EnquiryModel;
